import { useState, type FormEvent } from 'react'
import { authClient, authMessage } from '../lib/authClient'

/**
 * /reset-password?token=…  The link from the email lands here. On success the
 * person is sent to sign in with the password they just chose.
 */
export function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token') ?? ''
  const [password, setPassword] = useState('')
  const [again, setAgain] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    if (busy) return
    if (password !== again) {
      setError('Those two don’t match.')
      return
    }
    setBusy(true)
    setError(null)
    const { error } = await authClient.resetPassword({ newPassword: password, token })
    setBusy(false)
    if (error) {
      setError(authMessage(error))
      return
    }
    setDone(true)
  }

  return (
    <div className="lock">
      <form className="lock-card" onSubmit={submit}>
        <div className="lock-logo" aria-hidden="true">
          🥪
        </div>
        <h1>{done ? 'Password set' : 'Choose a password'}</h1>
        <p className="sub">{done ? 'You can sign in with it now.' : 'At least 8 characters.'}</p>

        <div className="stack">
          {error && <div className="banner error">{error}</div>}
          {!token && !done && (
            <div className="banner error">This link is missing its token. Open it from the email again.</div>
          )}

          {done ? (
            <a className="btn primary" href="/">
              Sign in
            </a>
          ) : (
            <>
              <div className="field">
                <label htmlFor="reset-pass">New password</label>
                <input
                  id="reset-pass"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  minLength={8}
                  autoFocus
                  required
                />
              </div>
              <div className="field">
                <label htmlFor="reset-again">Once more</label>
                <input
                  id="reset-again"
                  type="password"
                  value={again}
                  onChange={(e) => setAgain(e.target.value)}
                  autoComplete="new-password"
                  minLength={8}
                  required
                />
              </div>
              <button className="btn primary" type="submit" disabled={busy || !token || password.length < 8}>
                {busy ? 'Saving…' : 'Set password'}
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  )
}
